import formatInTimeZone from "date-fns-tz/formatInTimeZone";
import getTimezoneOffset from "date-fns-tz/getTimezoneOffset";
import format from "date-fns/format";
import subMilliseconds from "date-fns/subMilliseconds";

const DATE_TIME_ZONED_FORMAT = "hh:mmaaa MM/dd/yyyy";

const formatDateTime = (date: Date, timezone?: string | null): string => {
  if (!timezone) {
    return format(date, DATE_TIME_ZONED_FORMAT);
  }

  return formatInTimeZone(
    subMilliseconds(date, getTimezoneOffset(timezone, date)),
    timezone,
    DATE_TIME_ZONED_FORMAT
  );
};

export default formatDateTime;
